import React from 'react'
import { bool, string, shape, number } from 'prop-types'

import format from 'date-fns/format'

import Typography from 'components/atoms/Typography'
import RiasecBoxes from 'components/molecules/RiasecBoxes'

const AptitudeHistoryItem = ({ id, dataTestId, date, ratio, latest }) => {
  const dateString = new Date(date.replace(/\s/, 'T').replace(' UTC', '+00:00'))
  const parsedDate = format(dateString, 'EEE, dd MMMM yyyy')

  return (
    <div className="aptitude-history-item">
      <div className="aptitude-history-item__date">
        <Typography component="h3" variant="subheading">
          {latest && 'Hasil Tes Terakhir - '} {parsedDate}
        </Typography>
      </div>
      <RiasecBoxes ratio={ratio} />
      <div className="aptitude-history-item__link-detail">
        <a href={`/aptitude_test/report/${id}`} className="aptitude-history-item__link" data-testid={dataTestId}>
          Lihat selengkapnya...
        </a>
      </div>
      <style jsx>
        {`
          .aptitude-history-item {
            border-radius: 8px;
            box-shadow: 0 6px 16px 0 rgba(107, 143, 188, 0.1);
            background-color: #fff;
            padding: 16px;
            margin-bottom: 16px;

            &__date {
              display: flex;
              align-items: center;
            }
            &__link-detail {
              display: flex;
              flex-direction: column;
              a {
                margin-left: auto;
                align-self: flex-end;
                color: #00cbae;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

AptitudeHistoryItem.propTypes = {
  id: string.isRequired,
  date: string.isRequired,
  ratio: shape({
    R: number,
    I: number,
    A: number,
    S: number,
    E: number,
    C: number,
  }).isRequired,
  latest: bool,
  dataTestId: string,
}

export default AptitudeHistoryItem
